import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/app-button/app-button.js';
      import {AppButtonSize} from '@oicl/openbridge-webcomponents/dist/components/app-button/app-button.js';

      export interface Props {
     label?: string;
     checked?: boolean;
     showLabel?: boolean;
     integration?: boolean;
     size?: AppButtonSize;
     disabled?: boolean
   }

      
  
      export type {AppButtonSize} from '@oicl/openbridge-webcomponents/dist/components/app-button/app-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAppButton',
  props: {
    label: {},
    checked: { type: Boolean },
    showLabel: { type: Boolean },
    integration: { type: Boolean },
    size: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-app-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})